export function personLabel(person: { name: string | null; email: string | null }): string {
  return person.name?.trim() || person.email?.trim() || 'Unnamed user'
}

export function personLabelWithEmail(person: { name: string | null; email: string | null }): string {
  const label = personLabel(person)
  const email = person.email?.trim()
  return email && email !== label ? `${label} (${email})` : label
}
